<template>

  <div style="border: 1px solid #dedede;width: 95%;margin: 0 auto; display: block;">
    <div style="margin-left: 10px;color: #939393">拆分前序列号</div>
    <frame-form ref="after_sales_select_sn" component-param="after_sales_select_sn" :readonly="isDisable"
                :parent-data="{company_id:companyId}" ></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">产品明细</div>
    <frame-form ref="crm_asset_product_manage_readonly" style="padding-left: 100px"
                :parent-data="productDetail" component-param="crm_asset_product_manage" :readonly="true"></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;margin:10px auto 0; display: block;">
    <div style="margin-left: 10px;color: #939393">拆分后序列号</div>
    <frame-form ref="after_sales_sn_general" component-param="after_sales_sn_general" :readonly="isDisable" ></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">产品明细</div>
    <frame-form ref="crm_asset_product_manage" style="padding-left: 100px" :readonly="isDisable"
                component-param="crm_asset_product_manage" ></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">关联信息</div>
    <el-form>
      <el-row>
        <el-col :span="11">
          <el-form-item label="机会编号：" label-position="right" label-width="150px">
            <el-select v-model="chance_id" @change="getContractList" :disabled="isDisable">
              <el-option v-for="item in chanceList" :key="item.id" :label="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="合同编号：" label-position="right" label-width="150px">
            <el-select v-model="contract_no" :disabled="isDisable" clearable>
              <el-option v-for="item in contractList" :key="item.contract_no" :label="item.contract_no" :value="item.contract_no"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：" label-position="right" label-width="150px">
            <el-input v-model="remark" style="width: 100%" :disabled="isDisable" type="textarea" rows="3" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div v-if="!isDisable" style="margin: 10px 0 50px 0;text-align: center"><el-button type="primary" style="width: 150px" @click="saveData" >保存</el-button></div>

</template>

<script>
export default {
  name: "SplitSnOperate",
  inject:['$fn'],

  props: {
    companyId: {
      type: String,
      required: true
    },
    isDisable:{
      type: Boolean,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  provide() {
    return {
      $fn: {
        initProduct: () => {
          this.initProductDetail();
        }
      }
    }
  },

  watch: {
    companyId(value) {
      if(value){
        this.getChanceList(value);
        this.$refs.after_sales_select_sn.initForm();
      }else {
        this.chance_id = '';
        this.chanceList = [];
      }
    }
  },

  data() {
    return {
      chanceList: [],
      contractList:[],
      chance_id:'',
      contract_no:'',
      remark:'',
      productDetail:{
        detail_list:[],
      },
    }
  },


  created() {
    this.getChanceList(this.companyId);
  },

  mounted() {
    this.initData();
  },

  methods: {
    async getChanceList(company_id){
      if(!company_id){
        return;
      }
      this.chanceList = await this.$http('assetService.getChanceListByCompany',{company_id:company_id});
    },
    async getContractList(){
      this.contractList = await this.$http('assetService.getContractListByChance',{chance_id:this.chance_id});
    },

    async saveData(){
      if(!this.chance_id){
        this.$message.error('机会编号为空');
        return;
      }
      // if(!this.contract_no){
      //   this.$message.error('合同编号为空');
      //   return;
      // }
      if(!this.companyId){
        this.$message.error('公司为空');
        return;
      }
      let product_info_berfore = this.$refs.crm_asset_product_manage_readonly.formInfo;

      let data = await this.$refs.after_sales_select_sn.formInfo;
      let checkResult = this.checkSelectSnInfo(data);
      if(!checkResult){
        return;
      }

      let snInfo = this.$refs.after_sales_sn_general.formInfo;
      let check1 = this.checkSnInfoRequired('after_sales_sn_general', snInfo);
      if(!check1){
        return;
      }
      let productInfo = this.$refs.crm_asset_product_manage.formInfo;
      let productList = this.checkProductInfoRequired(productInfo);
      if(!productList){
        return;
      }

      let params = {
        company_id:this.companyId,
        chance_id:this.chance_id,
        contract_no:this.contract_no,
        remark:this.remark,
        operate:'split',
        sn_info_before:data,
        product_info_before:product_info_berfore?.detail_list,
        sn_info_after:snInfo,
        product_info_after:productList,

      }

      this.$http('assetService.splitSnOperate', params).then(() => {
        this.$message.success("操作成功");
        this.$fn.closeWindow();
        this.$fn.search();
      })

    },

    async initProductDetail() {
      let snInfo = this.$refs.after_sales_select_sn.formInfo;
      let productList = await this.$http('assetService.getProductItemBySn', {serial_number: snInfo.serial_number});
      this.productDetail.detail_list = [];
      for (let product of productList) {
        let item = {
          nanoid: product.id,
          product_id: product.product_id,
          cnt: product.cnt,
        }
        this.productDetail.detail_list.push(item);
      }
      this.$refs.crm_asset_product_manage_readonly.mergeFormData(this.productDetail);
      let snData = await this.$http('assetService.getAssetInfoBySn',{serial_number: snInfo.serial_number});
      this.chance_id = snData.chance_id;
      await this.getContractList();
      this.contract_no = snData.contract_no;
    },

    checkSelectSnInfo(data){
      let serialNumber = data.serial_number;
      if(!serialNumber){
        this.$message.error('未选择停用序列号');
        return false;
      }
      return true;
    },

    async checkSnInfoRequired(formId,data){
      let json = await this.$store.dispatch('core/getFormDef',formId);
      let items = json?.items;
      let snNotRequired = false;
      if(data['asset_type'] === 'hardware'){
        snNotRequired = true;
      }
      for (let item of items) {
        if(item.required){
          if(item.data_key === 'serial_number' && snNotRequired){
            continue;
          }
          if(!data[item.data_key]){
            this.$message.error(item.label+'不能为空');
            return false;
          }
        }
      }
      return true;
    },
    checkProductInfoRequired(data){
      let dataList = data?.detail_list || [];
      let list = [];
      for (let item of dataList) {
        if(item.product_id && item.cnt){
          list.push(item);
        }
      }
      if(list.length === 0){
        this.$message.error('产品明细不能为空');
        return false;
      }
      return list;
    },

    initData(){
      if(this.isDisable){
        let data = this.parentData;
        let otherContent = JSON.parse(data.other_content);
        let snInfoBefore = JSON.parse(data.sn_info_before);
        let productInfo = JSON.parse(data.product_info_before);
        let snInfoAfter = JSON.parse(data.sn_info_after);
        let productInfoAfter = JSON.parse(data.product_info_after);

        this.chance_id = otherContent.chance_id;
        this.contract_no = otherContent.contract_no;
        this.remark = otherContent.remark;

        setTimeout(() => {
          this.$refs.after_sales_select_sn.mergeFormData(snInfoBefore);
          let productData = {
            detail_list: productInfo,
          }
          this.$refs.crm_asset_product_manage_readonly.mergeFormData(productData);

          this.$refs.after_sales_sn_general.mergeFormData(snInfoAfter);
          let productDataAfterObj = {
            detail_list: productInfoAfter,
          }
          this.$refs.crm_asset_product_manage.mergeFormData(productDataAfterObj);
        },2000);
      }
    }
  }
}
</script>

<style scoped>

</style>